import "@mantine/charts/styles.css";
import {
  MantineProvider,
  createTheme,
  type MantineProviderProps,
} from "@mantine/core";
import "@mantine/core/styles.css";
import type { FC } from "react";

// theme files from mantinehub generator
import {
  CodeHighlightAdapterProvider,
  createHighlightJsAdapter,
} from "@mantine/code-highlight";
import { Notifications } from "@mantine/notifications";
import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import gherkin from "highlight.js/lib/languages/gherkin";
import json from "highlight.js/lib/languages/json";
import plaintext from "highlight.js/lib/languages/plaintext";
import typescript from "highlight.js/lib/languages/typescript";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
import { shadcnCssVariableResolver } from "./theme/cssVariableResolver";
import { shadcnTheme } from "./theme/theme";
// code highlight styles DO NOT REORDER
import "@mantine/code-highlight/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/nprogress/styles.css";
import "@mantine/spotlight/styles.css";
import "highlight.js/styles/atom-one-dark.min.css";
import "./font";
import "./theme/custom/button.css";
import "./theme/style.css";

hljs.registerLanguage("bash", bash);
hljs.registerLanguage("gherkin", gherkin);
hljs.registerLanguage("json", json);
hljs.registerLanguage("plaintext", plaintext);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("yaml", yaml);

const highlightJsAdapter = createHighlightJsAdapter(hljs);

type Props = MantineProviderProps & {};

/**
 * further customize the theme
 */
const theme = createTheme({
  ...shadcnTheme,
  fontFamily: "Geist Sans, sans-serif",
  fontFamilyMonospace: "Geist Mono, monospace",
  headings: {
    ...shadcnTheme.headings,
    fontFamily: "geist-sans, sans-serif",
  },
});

/**
 * create the theme provider for null apps
 * @returns
 */
export const ThemeProvider: FC<Props> = ({ children, ...props }) => (
  <MantineProvider
    theme={theme}
    defaultColorScheme="dark"
    cssVariablesResolver={shadcnCssVariableResolver}
    {...props}
  >
    <CodeHighlightAdapterProvider adapter={highlightJsAdapter}>
      <Notifications />
      {children}
    </CodeHighlightAdapterProvider>
  </MantineProvider>
);
